<ion-card class="card-common-blue ion-no-margin ion-margin-top">
  <!-- Card Header with Icon -->
  <ion-card-header>
    <ion-card-title>
      <div class="d-flex align-items-center gap-2">
        <span class="cst-icon icon-credit-card"></span>
        <span>
          {{ "ACCIDENT_DAMAGE_CLAIMS" | translate }}
        </span>
      </div>
    </ion-card-title>
  </ion-card-header>

  <ion-card-content>
    <ion-grid class="commonGrid ion-margin-top">
      <ion-row class="gridHead">
        <ion-col size="4">
          <span>{{ "ACCIDENT_DAMAGE_CLAIMS_DATE" | translate }}</span>
        </ion-col>
        <ion-col class="my-thin-col-first" size="4">
          <span>{{ "ACCIDENT_DAMAGE_CLAIMS_CLIENT_REF" | translate }}</span>
        </ion-col>
        <ion-col class="my-thin-col-first" size="4">
          <span>{{ "ACCIDENT_DAMAGE_CLAIMS_STATUS" | translate }}</span>
        </ion-col>
      </ion-row>

      <!-- Table Body: Loop through accident claims -->
      @for (claims of accidentClaims(); track $index) {
      <ion-row class="gridData">
        <!-- Claim Date: Formatted -->
        <ion-col class="claimDate" size="4">
          {{ (claims.accidentDate | formatDate: isMobileApp()) || "-" }}
        </ion-col>

        <!-- Client Reference -->
        <ion-col size="4"> {{ claims.clientRef || "-" }} </ion-col>

        <!-- Claim Status -->
        <ion-col size="4"> {{ claims.status || "-" }} </ion-col>
      </ion-row>
      }

      <!-- Empty State: Shown when no claims are available -->
      @if (accidentClaims().length === 0) {
      <div class="ion-padding text-center">
        {{ "MSG18" | translate }}
      </div>
      }
    </ion-grid>
  </ion-card-content>
</ion-card>